// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #0f1115;
  --bg-elevated: #161922;
  --border: #262b38;
  --text: #e7e9ee;
  --text-dim: #9aa1b2;
  --accent: #7c9dff;
  --accent-dim: #2a3358;
  --code-bg: #12141c;
  --radius: 8px;
  --max-width: 780px;
}

* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
}

body {
  background: var(--bg);
  color: var(--text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
  line-height: 1.6;
}

#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.site-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 16px 24px;
  background: rgba(15, 17, 21, 0.9);
  backdrop-filter: blur(6px);
  border-bottom: 1px solid var(--border);
}

.brand {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.02em;
  color: var(--text);
  white-space: nowrap;
}

.brand-logo {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.brand-dot {
  color: var(--accent);
}

.site-nav {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.nav-item {
  appearance: none;
  border: 1px solid transparent;
  background: transparent;
  color: var(--text-dim);
  font-size: 14px;
  font-family: inherit;
  padding: 8px 14px;
  border-radius: var(--radius);
  cursor: pointer;
}

.nav-item:hover {
  color: var(--text);
  background: var(--bg-elevated);
}

.nav-item.active {
  color: var(--text);
  background: var(--accent-dim);
  border-color: var(--accent);
}

.menu-toggle {
  display: none;
  appearance: none;
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text);
  font-size: 16px;
  line-height: 1;
  padding: 8px 12px;
  border-radius: var(--radius);
  cursor: pointer;
  margin-left: auto;
}

.menu-toggle:hover {
  background: var(--bg-elevated);
}

@media (max-width: 720px) {
  .menu-toggle {
    display: block;
  }

  .site-nav {
    display: none;
    flex-direction: column;
    gap: 2px;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: var(--bg);
    border-bottom: 1px solid var(--border);
    padding: 8px 16px 16px;
  }

  .site-nav.open {
    display: flex;
  }

  .nav-item {
    width: 100%;
    text-align: left;
  }
}

.site-main {
  flex: 1;
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 48px 24px 96px;
}

.site-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  border-top: 1px solid var(--border);
  padding: 24px;
  text-align: center;
  color: var(--text-dim);
  font-size: 13px;
}

.footer-sponsor {
  appearance: none;
  border: none;
  background: transparent;
  font-family: inherit;
  cursor: pointer;
  color: var(--accent);
  font-size: 13px;
  font-weight: 600;
}

.footer-sponsor:hover {
  text-decoration: underline;
}

h1, h2, h3 {
  color: var(--text);
  font-weight: 700;
  line-height: 1.3;
}

h1 {
  font-size: 32px;
  margin: 0 0 8px;
}

.hero {
  display: block;
  width: 100%;
  max-height: 320px;
  object-fit: cover;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  margin: 0 0 32px;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin: 24px 0 8px;
}

.feature-card {
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  border-radius: var(--radius);
  padding: 16px 20px;
}

.feature-card h3 {
  margin: 0 0 8px;
}

.feature-card p {
  margin: 0;
  font-size: 14px;
}

@media (max-width: 620px) {
  .feature-grid {
    grid-template-columns: 1fr;
  }
}

h2 {
  font-size: 22px;
  margin: 40px 0 12px;
  padding-top: 8px;
  border-top: 1px solid var(--border);
}

h2:first-child {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}

h3 {
  font-size: 17px;
  margin: 24px 0 8px;
}

p {
  color: var(--text-dim);
  margin: 0 0 16px;
}

.lede {
  font-size: 17px;
  color: var(--text);
}

.overview-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 28px;
}

.repo-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--accent);
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  padding: 8px 14px;
  border-radius: var(--radius);
}

.repo-link:hover {
  border-color: var(--accent);
  background: var(--accent-dim);
}

ul, ol {
  color: var(--text-dim);
  padding-left: 20px;
  margin: 0 0 16px;
}

li {
  margin-bottom: 6px;
}

code {
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 13px;
  background: var(--code-bg);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 1px 5px;
  color: var(--accent);
}

pre {
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 13px;
  background: var(--code-bg);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  overflow-x: auto;
  color: var(--text);
  margin: 0 0 20px;
}

pre code {
  background: none;
  border: none;
  padding: 0;
  color: inherit;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 0 20px;
  font-size: 14px;
}

th, td {
  text-align: left;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border);
  vertical-align: top;
}

th {
  color: var(--text-dim);
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

td {
  color: var(--text-dim);
}

td a {
  color: var(--accent);
  text-decoration: none;
}

td a:hover {
  text-decoration: underline;
}

td code {
  color: var(--accent);
}

.callout {
  border: 1px solid var(--border);
  border-left: 3px solid var(--accent);
  background: var(--bg-elevated);
  border-radius: var(--radius);
  padding: 16px 20px;
  margin: 0 0 20px;
}

.callout-title {
  display: block;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--accent);
  margin-bottom: 8px;
}

.toc-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--accent);
  margin: 0 0 8px;
}

.toc {
  list-style: none;
  padding: 16px 20px;
  margin: 0 0 28px;
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  border-radius: var(--radius);
}

.toc li {
  margin: 0;
}

.toc a {
  color: var(--accent);
  text-decoration: none;
  font-size: 14px;
  display: block;
  padding: 4px 0;
}

.toc a:hover {
  text-decoration: underline;
}

.diagram-wrap {
  margin: 0 0 24px;
  overflow-x: auto;
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  border-radius: var(--radius);
}

.diagram {
  display: block;
  width: 100%;
  height: auto;
  min-width: 560px;
}

.two-col-pre {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 0 0 20px;
}

.two-col-pre pre {
  margin: 0;
}

.two-col-pre .pre-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--accent);
  margin: 0 0 6px;
}

@media (max-width: 720px) {
  .two-col-pre {
    grid-template-columns: 1fr;
  }
}

.playground-form {
  margin: 0 0 32px;
}

.playground-open {
  appearance: none;
  border: none;
  background: var(--accent);
  color: #0f1115;
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  padding: 12px 20px;
  border-radius: var(--radius);
  cursor: pointer;
}

.playground-open:hover {
  opacity: 0.9;
}

.demo-box {
  position: relative;
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  border-radius: var(--radius);
  padding: 20px;
  margin: 0 0 24px;
}

.demo-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--accent);
  margin-bottom: 12px;
}

.demo-btn {
  appearance: none;
  border: 1px solid var(--border);
  background: var(--bg);
  color: var(--text);
  font-family: inherit;
  font-size: 14px;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
}

.demo-btn:hover {
  border-color: var(--accent);
}

.demo-btn.active {
  background: var(--accent-dim);
  border-color: var(--accent);
  color: var(--text);
}

.demo-input {
  width: 100%;
  border: 1px solid var(--border);
  background: var(--bg);
  color: var(--text);
  font-family: inherit;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.demo-input:focus {
  outline: none;
  border-color: var(--accent);
}

.demo-empty {
  margin: 8px 0 0;
  font-size: 13px;
  color: var(--text-dim);
  font-style: italic;
}

.demo-todo-list {
  list-style: none;
  padding: 0;
  margin: 12px 0 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.demo-todo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 14px;
}

.demo-todo span {
  cursor: pointer;
}

.demo-todo.done span {
  text-decoration: line-through;
  color: var(--text-dim);
}

.demo-todo-remove {
  appearance: none;
  border: none;
  background: transparent;
  color: var(--text-dim);
  cursor: pointer;
  font-size: 13px;
  padding: 2px 6px;
}

.demo-todo-remove:hover {
  color: var(--text);
}

.demo-accordion {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.demo-faq {
  border: 1px solid var(--border);
  border-radius: 6px;
  overflow: hidden;
}

.demo-faq-question {
  display: block;
  width: 100%;
  text-align: left;
  appearance: none;
  border: none;
  background: var(--bg);
  color: var(--text);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 14px;
  cursor: pointer;
}

.demo-faq-question:hover {
  background: var(--accent-dim);
}

.demo-faq-answer {
  margin: 0;
  padding: 0 14px 12px;
  font-size: 13px;
}

.demo-counter {
  display: flex;
  align-items: center;
  gap: 16px;
}

.demo-count {
  font-size: 18px;
  font-weight: 700;
  min-width: 20px;
  text-align: center;
}

.demo-buttons {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.demo-message {
  margin: 12px 0 0;
  color: var(--text);
}

.demo-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.demo-list li {
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 14px;
}

.demo-log {
  list-style: none;
  padding: 0;
  margin: 12px 0 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.demo-log li {
  font-size: 13px;
  color: var(--text-dim);
  font-family: "SF Mono", Menlo, Consolas, monospace;
}

.demo-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.demo-row .demo-input {
  margin-bottom: 0;
  max-width: 240px;
}

.demo-chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.demo-chip {
  appearance: none;
  border: 1px solid var(--border);
  background: var(--bg);
  color: var(--text);
  font-family: inherit;
  font-size: 14px;
  padding: 8px 14px;
  border-radius: 999px;
  cursor: pointer;
}

.demo-chip:hover {
  border-color: var(--accent);
}

.flow {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 20px 0;
}

.flow-step {
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  border-radius: var(--radius);
  padding: 14px 18px;
}

.flow-step h3 {
  margin: 0 0 6px;
  font-size: 15px;
}

.flow-step p {
  margin: 0;
  font-size: 13px;
}

.flow-arrow {
  text-align: center;
  color: var(--accent);
  font-size: 20px;
  line-height: 1;
  padding: 4px 0;
}

.flow-branch {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 10px;
  margin: 0 0 20px;
}

.flow-branch-item {
  border: 1px dashed var(--border);
  border-radius: var(--radius);
  padding: 12px 14px;
}

.flow-branch-item h3 {
  margin: 0 0 6px;
  font-size: 13px;
  color: var(--accent);
}

.flow-branch-item p {
  margin: 0;
  font-size: 12px;
}

.sponsor-row {
  display: flex;
  justify-content: center;
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  border-radius: var(--radius);
  padding: 24px;
}

.sponsor-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.sponsor-qr img {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
}

.sponsor-caption {
  font-weight: 700;
  font-size: 14px;
  color: var(--accent);
}

.example-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin: 16px 0 40px;
}

.example-code, .example-output {
  min-width: 0;
}

.example-output {
  display: flex;
  flex-direction: column;
}

.example-output .demo-box {
  margin: 0;
  flex: 1;
}

.copy-command {
  position: relative;
  margin: 0 0 20px;
}

.copy-command pre {
  margin: 0;
  padding-right: 88px;
}

.copy-command-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  appearance: none;
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  color: var(--text);
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  cursor: pointer;
}

.copy-command-btn:hover {
  border-color: var(--accent);
}

.copy-command-btn.copied {
  color: var(--accent);
  border-color: var(--accent);
}

.code-viewer {
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--code-bg);
  overflow: hidden;
  margin: 0 0 20px;
}

.code-viewer-tabs {
  display: flex;
  flex-wrap: wrap;
  background: var(--bg-elevated);
  border-bottom: 1px solid var(--border);
}

.code-tab {
  appearance: none;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-dim);
  font-family: inherit;
  font-size: 13px;
  padding: 10px 16px;
  cursor: pointer;
}

.code-tab:hover {
  color: var(--text);
}

.code-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.code-viewer-body {
  margin: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  color: var(--text);
  padding: 16px;
  font-size: 13px;
  max-height: 420px;
  overflow-y: auto;
  overflow-x: auto;
}

html:has(.contrib-layout),
body:has(.contrib-layout),
#root:has(.contrib-layout) {
  height: 100%;
}

#root:has(.contrib-layout) {
  height: 100vh;
  overflow: hidden;
}

.site-main.wide {
  max-width: none;
  width: 100%;
  padding: 0;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.contrib-layout {
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.contrib-scrim {
  display: none;
}

.contrib-nav {
  width: 252px;
  flex-shrink: 0;
  border-right: 1px solid var(--border);
  background: var(--bg-elevated);
  overflow-y: auto;
  padding: 16px 12px 32px;
}

.contrib-nav-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 8px 16px;
}

.contrib-nav-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--accent);
}

.contrib-nav-close {
  display: none;
  appearance: none;
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text);
  font-family: inherit;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: var(--radius);
  cursor: pointer;
}

.contrib-nav .toc-label {
  margin: 16px 8px 6px;
}

.contrib-nav .toc-label:first-child {
  margin-top: 0;
}

.contrib-nav-item {
  display: block;
  width: 100%;
  appearance: none;
  border: 1px solid transparent;
  background: transparent;
  color: var(--text-dim);
  font-family: inherit;
  font-size: 13px;
  text-align: left;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  line-height: 1.35;
}

.contrib-nav-item:hover {
  color: var(--text);
  background: var(--bg);
}

.contrib-nav-item.active {
  color: var(--text);
  background: var(--accent-dim);
  border-color: var(--accent);
}

.contrib-content {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.contrib-toolbar {
  display: none;
  position: sticky;
  top: 0;
  z-index: 5;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(15, 17, 21, 0.92);
  backdrop-filter: blur(6px);
  border-bottom: 1px solid var(--border);
}

.contrib-menu-btn {
  appearance: none;
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  color: var(--text);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: var(--radius);
  cursor: pointer;
}

.contrib-menu-btn:hover {
  border-color: var(--accent);
}

.contrib-burger {
  display: block;
  width: 16px;
  height: 2px;
  background: currentColor;
  box-shadow: 0 -5px 0 currentColor, 0 5px 0 currentColor;
}

.contrib-article {
  max-width: 820px;
  padding: 28px 40px 80px;
}

.contrib-article h1 {
  margin-top: 0;
}

.contrib-article > h2:first-child {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}

@media (max-width: 900px) {
  .contrib-toolbar {
    display: flex;
  }

  .contrib-nav-close {
    display: inline-flex;
  }

  .contrib-scrim {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 30;
  }

  .contrib-layout.nav-open .contrib-scrim {
    display: block;
  }

  .contrib-nav {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 31;
    width: min(280px, 86vw);
    transform: translateX(-105%);
    transition: transform 0.2s ease;
    box-shadow: none;
    padding-top: 20px;
  }

  .contrib-layout.nav-open .contrib-nav {
    transform: translateX(0);
    box-shadow: 8px 0 32px rgba(0, 0, 0, 0.35);
  }

  .contrib-article {
    padding: 20px 20px 80px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wFAAwF;EACxF,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,qBAAqB;IACrB,sCAAsC;IACtC,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,OAAO;EACP,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mCAAmC;EACnC,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,0CAA0C;EAC5C;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[":root {\n  --bg: #0f1115;\n  --bg-elevated: #161922;\n  --border: #262b38;\n  --text: #e7e9ee;\n  --text-dim: #9aa1b2;\n  --accent: #7c9dff;\n  --accent-dim: #2a3358;\n  --code-bg: #12141c;\n  --radius: 8px;\n  --max-width: 780px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  background: var(--bg);\n  color: var(--text);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif;\n  line-height: 1.6;\n}\n\n#root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.site-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  padding: 16px 24px;\n  background: rgba(15, 17, 21, 0.9);\n  backdrop-filter: blur(6px);\n  border-bottom: 1px solid var(--border);\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  font-size: 18px;\n  letter-spacing: 0.02em;\n  color: var(--text);\n  white-space: nowrap;\n}\n\n.brand-logo {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.brand-dot {\n  color: var(--accent);\n}\n\n.site-nav {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.nav-item {\n  appearance: none;\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--text-dim);\n  font-size: 14px;\n  font-family: inherit;\n  padding: 8px 14px;\n  border-radius: var(--radius);\n  cursor: pointer;\n}\n\n.nav-item:hover {\n  color: var(--text);\n  background: var(--bg-elevated);\n}\n\n.nav-item.active {\n  color: var(--text);\n  background: var(--accent-dim);\n  border-color: var(--accent);\n}\n\n.menu-toggle {\n  display: none;\n  appearance: none;\n  border: 1px solid var(--border);\n  background: transparent;\n  color: var(--text);\n  font-size: 16px;\n  line-height: 1;\n  padding: 8px 12px;\n  border-radius: var(--radius);\n  cursor: pointer;\n  margin-left: auto;\n}\n\n.menu-toggle:hover {\n  background: var(--bg-elevated);\n}\n\n@media (max-width: 720px) {\n  .menu-toggle {\n    display: block;\n  }\n\n  .site-nav {\n    display: none;\n    flex-direction: column;\n    gap: 2px;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: var(--bg);\n    border-bottom: 1px solid var(--border);\n    padding: 8px 16px 16px;\n  }\n\n  .site-nav.open {\n    display: flex;\n  }\n\n  .nav-item {\n    width: 100%;\n    text-align: left;\n  }\n}\n\n.site-main {\n  flex: 1;\n  width: 100%;\n  max-width: var(--max-width);\n  margin: 0 auto;\n  padding: 48px 24px 96px;\n}\n\n.site-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  border-top: 1px solid var(--border);\n  padding: 24px;\n  text-align: center;\n  color: var(--text-dim);\n  font-size: 13px;\n}\n\n.footer-sponsor {\n  appearance: none;\n  border: none;\n  background: transparent;\n  font-family: inherit;\n  cursor: pointer;\n  color: var(--accent);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.footer-sponsor:hover {\n  text-decoration: underline;\n}\n\nh1, h2, h3 {\n  color: var(--text);\n  font-weight: 700;\n  line-height: 1.3;\n}\n\nh1 {\n  font-size: 32px;\n  margin: 0 0 8px;\n}\n\n.hero {\n  display: block;\n  width: 100%;\n  max-height: 320px;\n  object-fit: cover;\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  margin: 0 0 32px;\n}\n\n.feature-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  margin: 24px 0 8px;\n}\n\n.feature-card {\n  border: 1px solid var(--border);\n  background: var(--bg-elevated);\n  border-radius: var(--radius);\n  padding: 16px 20px;\n}\n\n.feature-card h3 {\n  margin: 0 0 8px;\n}\n\n.feature-card p {\n  margin: 0;\n  font-size: 14px;\n}\n\n@media (max-width: 620px) {\n  .feature-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\nh2 {\n  font-size: 22px;\n  margin: 40px 0 12px;\n  padding-top: 8px;\n  border-top: 1px solid var(--border);\n}\n\nh2:first-child {\n  border-top: none;\n  padding-top: 0;\n  margin-top: 0;\n}\n\nh3 {\n  font-size: 17px;\n  margin: 24px 0 8px;\n}\n\np {\n  color: var(--text-dim);\n  margin: 0 0 16px;\n}\n\n.lede {\n  font-size: 17px;\n  color: var(--text);\n}\n\n.overview-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0 0 28px;\n}\n\n.repo-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--accent);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid var(--border);\n  background: var(--bg-elevated);\n  padding: 8px 14px;\n  border-radius: var(--radius);\n}\n\n.repo-link:hover {\n  border-color: var(--accent);\n  background: var(--accent-dim);\n}\n\nul, ol {\n  color: var(--text-dim);\n  padding-left: 20px;\n  margin: 0 0 16px;\n}\n\nli {\n  margin-bottom: 6px;\n}\n\ncode {\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 13px;\n  background: var(--code-bg);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 1px 5px;\n  color: var(--accent);\n}\n\npre {\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 13px;\n  background: var(--code-bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n  overflow-x: auto;\n  color: var(--text);\n  margin: 0 0 20px;\n}\n\npre code {\n  background: none;\n  border: none;\n  padding: 0;\n  color: inherit;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0 0 20px;\n  font-size: 14px;\n}\n\nth, td {\n  text-align: left;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border);\n  vertical-align: top;\n}\n\nth {\n  color: var(--text-dim);\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\ntd {\n  color: var(--text-dim);\n}\n\ntd a {\n  color: var(--accent);\n  text-decoration: none;\n}\n\ntd a:hover {\n  text-decoration: underline;\n}\n\ntd code {\n  color: var(--accent);\n}\n\n.callout {\n  border: 1px solid var(--border);\n  border-left: 3px solid var(--accent);\n  background: var(--bg-elevated);\n  border-radius: var(--radius);\n  padding: 16px 20px;\n  margin: 0 0 20px;\n}\n\n.callout-title {\n  display: block;\n  font-weight: 700;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--accent);\n  margin-bottom: 8px;\n}\n\n.toc-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--accent);\n  margin: 0 0 8px;\n}\n\n.toc {\n  list-style: none;\n  padding: 16px 20px;\n  margin: 0 0 28px;\n  border: 1px solid var(--border);\n  background: var(--bg-elevated);\n  border-radius: var(--radius);\n}\n\n.toc li {\n  margin: 0;\n}\n\n.toc a {\n  color: var(--accent);\n  text-decoration: none;\n  font-size: 14px;\n  display: block;\n  padding: 4px 0;\n}\n\n.toc a:hover {\n  text-decoration: underline;\n}\n\n.diagram-wrap {\n  margin: 0 0 24px;\n  overflow-x: auto;\n  border: 1px solid var(--border);\n  background: var(--bg-elevated);\n  border-radius: var(--radius);\n}\n\n.diagram {\n  display: block;\n  width: 100%;\n  height: auto;\n  min-width: 560px;\n}\n\n.two-col-pre {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin: 0 0 20px;\n}\n\n.two-col-pre pre {\n  margin: 0;\n}\n\n.two-col-pre .pre-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--accent);\n  margin: 0 0 6px;\n}\n\n@media (max-width: 720px) {\n  .two-col-pre {\n    grid-template-columns: 1fr;\n  }\n}\n\n.playground-form {\n  margin: 0 0 32px;\n}\n\n.playground-open {\n  appearance: none;\n  border: none;\n  background: var(--accent);\n  color: #0f1115;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 700;\n  padding: 12px 20px;\n  border-radius: var(--radius);\n  cursor: pointer;\n}\n\n.playground-open:hover {\n  opacity: 0.9;\n}\n\n.demo-box {\n  position: relative;\n  border: 1px solid var(--border);\n  background: var(--bg-elevated);\n  border-radius: var(--radius);\n  padding: 20px;\n  margin: 0 0 24px;\n}\n\n.demo-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--accent);\n  margin-bottom: 12px;\n}\n\n.demo-btn {\n  appearance: none;\n  border: 1px solid var(--border);\n  background: var(--bg);\n  color: var(--text);\n  font-family: inherit;\n  font-size: 14px;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.demo-btn:hover {\n  border-color: var(--accent);\n}\n\n.demo-btn.active {\n  background: var(--accent-dim);\n  border-color: var(--accent);\n  color: var(--text);\n}\n\n.demo-input {\n  width: 100%;\n  border: 1px solid var(--border);\n  background: var(--bg);\n  color: var(--text);\n  font-family: inherit;\n  font-size: 14px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  margin-bottom: 12px;\n}\n\n.demo-input:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n\n.demo-empty {\n  margin: 8px 0 0;\n  font-size: 13px;\n  color: var(--text-dim);\n  font-style: italic;\n}\n\n.demo-todo-list {\n  list-style: none;\n  padding: 0;\n  margin: 12px 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.demo-todo {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 8px 10px;\n  font-size: 14px;\n}\n\n.demo-todo span {\n  cursor: pointer;\n}\n\n.demo-todo.done span {\n  text-decoration: line-through;\n  color: var(--text-dim);\n}\n\n.demo-todo-remove {\n  appearance: none;\n  border: none;\n  background: transparent;\n  color: var(--text-dim);\n  cursor: pointer;\n  font-size: 13px;\n  padding: 2px 6px;\n}\n\n.demo-todo-remove:hover {\n  color: var(--text);\n}\n\n.demo-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.demo-faq {\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.demo-faq-question {\n  display: block;\n  width: 100%;\n  text-align: left;\n  appearance: none;\n  border: none;\n  background: var(--bg);\n  color: var(--text);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 10px 14px;\n  cursor: pointer;\n}\n\n.demo-faq-question:hover {\n  background: var(--accent-dim);\n}\n\n.demo-faq-answer {\n  margin: 0;\n  padding: 0 14px 12px;\n  font-size: 13px;\n}\n\n.demo-counter {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.demo-count {\n  font-size: 18px;\n  font-weight: 700;\n  min-width: 20px;\n  text-align: center;\n}\n\n.demo-buttons {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.demo-message {\n  margin: 12px 0 0;\n  color: var(--text);\n}\n\n.demo-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.demo-list li {\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 14px;\n}\n\n.demo-log {\n  list-style: none;\n  padding: 0;\n  margin: 12px 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.demo-log li {\n  font-size: 13px;\n  color: var(--text-dim);\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n}\n\n.demo-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.demo-row .demo-input {\n  margin-bottom: 0;\n  max-width: 240px;\n}\n\n.demo-chips {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.demo-chip {\n  appearance: none;\n  border: 1px solid var(--border);\n  background: var(--bg);\n  color: var(--text);\n  font-family: inherit;\n  font-size: 14px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  cursor: pointer;\n}\n\n.demo-chip:hover {\n  border-color: var(--accent);\n}\n\n.flow {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin: 20px 0;\n}\n\n.flow-step {\n  border: 1px solid var(--border);\n  background: var(--bg-elevated);\n  border-radius: var(--radius);\n  padding: 14px 18px;\n}\n\n.flow-step h3 {\n  margin: 0 0 6px;\n  font-size: 15px;\n}\n\n.flow-step p {\n  margin: 0;\n  font-size: 13px;\n}\n\n.flow-arrow {\n  text-align: center;\n  color: var(--accent);\n  font-size: 20px;\n  line-height: 1;\n  padding: 4px 0;\n}\n\n.flow-branch {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 10px;\n  margin: 0 0 20px;\n}\n\n.flow-branch-item {\n  border: 1px dashed var(--border);\n  border-radius: var(--radius);\n  padding: 12px 14px;\n}\n\n.flow-branch-item h3 {\n  margin: 0 0 6px;\n  font-size: 13px;\n  color: var(--accent);\n}\n\n.flow-branch-item p {\n  margin: 0;\n  font-size: 12px;\n}\n\n.sponsor-row {\n  display: flex;\n  justify-content: center;\n  border: 1px solid var(--border);\n  background: var(--bg-elevated);\n  border-radius: var(--radius);\n  padding: 24px;\n}\n\n.sponsor-qr {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.sponsor-qr img {\n  width: 160px;\n  height: 160px;\n  border-radius: 8px;\n  background: #fff;\n  padding: 8px;\n}\n\n.sponsor-caption {\n  font-weight: 700;\n  font-size: 14px;\n  color: var(--accent);\n}\n\n.example-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin: 16px 0 40px;\n}\n\n.example-code, .example-output {\n  min-width: 0;\n}\n\n.example-output {\n  display: flex;\n  flex-direction: column;\n}\n\n.example-output .demo-box {\n  margin: 0;\n  flex: 1;\n}\n\n.copy-command {\n  position: relative;\n  margin: 0 0 20px;\n}\n\n.copy-command pre {\n  margin: 0;\n  padding-right: 88px;\n}\n\n.copy-command-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  appearance: none;\n  border: 1px solid var(--border);\n  background: var(--bg-elevated);\n  color: var(--text);\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.copy-command-btn:hover {\n  border-color: var(--accent);\n}\n\n.copy-command-btn.copied {\n  color: var(--accent);\n  border-color: var(--accent);\n}\n\n.code-viewer {\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--code-bg);\n  overflow: hidden;\n  margin: 0 0 20px;\n}\n\n.code-viewer-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  background: var(--bg-elevated);\n  border-bottom: 1px solid var(--border);\n}\n\n.code-tab {\n  appearance: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--text-dim);\n  font-family: inherit;\n  font-size: 13px;\n  padding: 10px 16px;\n  cursor: pointer;\n}\n\n.code-tab:hover {\n  color: var(--text);\n}\n\n.code-tab.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n.code-viewer-body {\n  margin: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  color: var(--text);\n  padding: 16px;\n  font-size: 13px;\n  max-height: 420px;\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\nhtml:has(.contrib-layout),\nbody:has(.contrib-layout),\n#root:has(.contrib-layout) {\n  height: 100%;\n}\n\n#root:has(.contrib-layout) {\n  height: 100vh;\n  overflow: hidden;\n}\n\n.site-main.wide {\n  max-width: none;\n  width: 100%;\n  padding: 0;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.contrib-layout {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.contrib-scrim {\n  display: none;\n}\n\n.contrib-nav {\n  width: 252px;\n  flex-shrink: 0;\n  border-right: 1px solid var(--border);\n  background: var(--bg-elevated);\n  overflow-y: auto;\n  padding: 16px 12px 32px;\n}\n\n.contrib-nav-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 4px 8px 16px;\n}\n\n.contrib-nav-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--accent);\n}\n\n.contrib-nav-close {\n  display: none;\n  appearance: none;\n  border: 1px solid var(--border);\n  background: transparent;\n  color: var(--text);\n  font-family: inherit;\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: var(--radius);\n  cursor: pointer;\n}\n\n.contrib-nav .toc-label {\n  margin: 16px 8px 6px;\n}\n\n.contrib-nav .toc-label:first-child {\n  margin-top: 0;\n}\n\n.contrib-nav-item {\n  display: block;\n  width: 100%;\n  appearance: none;\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--text-dim);\n  font-family: inherit;\n  font-size: 13px;\n  text-align: left;\n  padding: 8px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  line-height: 1.35;\n}\n\n.contrib-nav-item:hover {\n  color: var(--text);\n  background: var(--bg);\n}\n\n.contrib-nav-item.active {\n  color: var(--text);\n  background: var(--accent-dim);\n  border-color: var(--accent);\n}\n\n.contrib-content {\n  flex: 1;\n  min-width: 0;\n  overflow-y: auto;\n  overflow-x: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.contrib-toolbar {\n  display: none;\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: rgba(15, 17, 21, 0.92);\n  backdrop-filter: blur(6px);\n  border-bottom: 1px solid var(--border);\n}\n\n.contrib-menu-btn {\n  appearance: none;\n  border: 1px solid var(--border);\n  background: var(--bg-elevated);\n  color: var(--text);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  border-radius: var(--radius);\n  cursor: pointer;\n}\n\n.contrib-menu-btn:hover {\n  border-color: var(--accent);\n}\n\n.contrib-burger {\n  display: block;\n  width: 16px;\n  height: 2px;\n  background: currentColor;\n  box-shadow: 0 -5px 0 currentColor, 0 5px 0 currentColor;\n}\n\n.contrib-article {\n  max-width: 820px;\n  padding: 28px 40px 80px;\n}\n\n.contrib-article h1 {\n  margin-top: 0;\n}\n\n.contrib-article > h2:first-child {\n  border-top: none;\n  padding-top: 0;\n  margin-top: 0;\n}\n\n@media (max-width: 900px) {\n  .contrib-toolbar {\n    display: flex;\n  }\n\n  .contrib-nav-close {\n    display: inline-flex;\n  }\n\n  .contrib-scrim {\n    display: none;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 30;\n  }\n\n  .contrib-layout.nav-open .contrib-scrim {\n    display: block;\n  }\n\n  .contrib-nav {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    z-index: 31;\n    width: min(280px, 86vw);\n    transform: translateX(-105%);\n    transition: transform 0.2s ease;\n    box-shadow: none;\n    padding-top: 20px;\n  }\n\n  .contrib-layout.nav-open .contrib-nav {\n    transform: translateX(0);\n    box-shadow: 8px 0 32px rgba(0, 0, 0, 0.35);\n  }\n\n  .contrib-article {\n    padding: 20px 20px 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
